import Colors from 'modules/Colors'
import { CSSProperties, SVGProps } from 'react'

interface TiktokFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const TiktokFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: TiktokFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.7619 11.4163C29.5594 11.3116 29.3623 11.1969 29.1713 11.0725C28.6158 10.7053 28.1065 10.2726 27.6544 9.78375C26.5231 8.48938 26.1006 7.17625 25.945 6.25688H25.9513C25.8213 5.49375 25.875 5 25.8831 5H20.7306V24.9237C20.7306 25.1912 20.7306 25.4556 20.7194 25.7169C20.7194 25.7494 20.7163 25.7794 20.7144 25.8144C20.7144 25.8287 20.7144 25.8437 20.7113 25.8587C20.7113 25.8625 20.7113 25.8663 20.7113 25.87C20.6569 26.5849 20.4278 27.2754 20.044 27.8809C19.6601 28.4864 19.1334 28.9884 18.51 29.3425C17.8603 29.7121 17.1256 29.906 16.3781 29.905C13.9775 29.905 12.0319 27.9475 12.0319 25.53C12.0319 23.1125 13.9775 21.155 16.3781 21.155C16.8326 21.1546 17.2842 21.2261 17.7163 21.3669L17.7225 16.1206C16.4109 15.9512 15.0783 16.0554 13.809 16.4268C12.5396 16.7981 11.361 17.4285 10.3475 18.2781C9.45942 19.0498 8.71281 19.9704 8.14126 20.9988C7.92376 21.3738 7.10313 22.8806 7.00376 25.3263C6.94126 26.7144 7.35813 28.1525 7.55688 28.7469V28.7594C7.68188 29.1094 8.16626 30.3038 8.95563 31.3106C9.59215 32.1183 10.3442 32.8278 11.1875 33.4163V33.4037L11.2 33.4163C13.6944 35.1113 16.46 35 16.46 35C16.9388 34.9806 18.5425 35 20.3638 34.1369C22.3838 33.18 23.5338 31.7544 23.5338 31.7544C24.2684 30.9026 24.8526 29.9318 25.2613 28.8838C25.7275 27.6581 25.8831 26.1881 25.8831 25.6006V15.0306C25.9456 15.0681 26.7781 15.6187 26.7781 15.6187C26.7781 15.6187 27.9775 16.3875 29.8488 16.8881C31.1913 17.2444 33 17.3194 33 17.3194V12.2044C32.3663 12.2731 31.0794 12.0731 29.7619 11.4163Z"
                fill={color}
            />
        </svg>
    )
}

export default TiktokFlatIcon
